"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _tracking = require("settings-ui-app/utils/tracking");

var _FormsContainer = _interopRequireDefault(require("./containers/FormsContainer"));

var _FormSubmissionsSettingsContainer = _interopRequireDefault(require("./containers/FormSubmissionsSettingsContainer"));

var _AsyncContainers = require("./AsyncContainers");

var _Urls = require("./constants/Urls");

var _default = _react.default.createElement(_reactRouter.Route, {
  path: _Urls.MODULE_PATH,
  component: _FormsContainer.default
}, _react.default.createElement(_reactRouter.IndexRedirect, {
  to: _Urls.STYLES_PATH
}), _react.default.createElement(_reactRouter.Route, {
  path: _Urls.SUBMISSIONS_SETTINGS_PATH,
  component: _FormSubmissionsSettingsContainer.default,
  onEnter: (0, _tracking.trackScreenUsingSideNav)(_Urls.SUBMISSIONS_SETTINGS_PATH)
}), _react.default.createElement(_reactRouter.Route, {
  path: _Urls.STYLES_PATH,
  component: _AsyncContainers.AsyncFormStyleContainer,
  onEnter: (0, _tracking.trackScreenUsingSideNav)(_Urls.STYLES_PATH)
}), _react.default.createElement(_reactRouter.Route, {
  path: _Urls.NON_HUBSPOT_PATH,
  component: _AsyncContainers.AsyncCollectedFormsContainer,
  onEnter: (0, _tracking.trackScreenUsingSideNav)(_Urls.NON_HUBSPOT_PATH)
}));

exports.default = _default;
module.exports = exports.default;